import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Button } from 'reactstrap';
import classNames from 'classnames';
import propTypes from 'prop-types';

const _isSnapSupported = () => {
  const snap = 'snap' in window;
  return snap !== undefined;
}

export default class ButtonSnapPay extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      isSupported: _isSnapSupported()
    }
  }
  _handleOpenSnap = ()=> {
    try {
      if(this.state.isSupported){
        window.snap.pay(this.props.snapToken,{
          onSuccess: (r) => this.props.onSuccess(r),
          onPending: (r) => this.props.onPending(r),
          onError: (e) => this.props.onError(e),
          onClose: this.props.onClose,
          language: 'en'
        })
      }
      else{
        window.location = this.props.redirectUrl;
      }
    } catch (error) {
      window.location = this.props.redirectUrl;
    }
  }

  _handleOnClick = (e) => {
    e.preventDefault();
    this._handleOpenSnap();
  }

  render(){
    return (
      <Button
        id={this.props.id}
        className={classNames(this.props.className, { 'd-none': this.props.hide, 'disabled': (this.props.disabled||this.props.snapToken === null)})}
        disabled={this.props.disabled||this.props.snapToken === null}
        color={this.props.color}
        size={this.props.size}
        block={this.props.block}
        tag={this.state.isSupported? 'button': 'a'}
        href={this.props.redirectUrl}
        onClick={this._handleOnClick}
      >
        {this.props.children}
      </Button>
    )
  }
}

ButtonSnapPay.defaultProps = {
  snapToken: null,
  disabled: false,
  hide: false,
  color: 'default',
  size: 'sm',
  block: false
}

ButtonSnapPay.propTypes = {
  snapToken: propTypes.string,
  id: propTypes.string,
  className: propTypes.string,
  disabled: propTypes.bool,
  hide: propTypes.bool,
  color: propTypes.string,
  size: propTypes.string,
  block: propTypes.bool,
  redirectUrl: propTypes.string,
  onSuccess: propTypes.func,
  onPending: propTypes.func,
  onError: propTypes.func,
  onClose: propTypes.func,
}